export const HEADER_MENU_CONFIG = [
  {
    action: "logout",
    label: "logout",
    icon:'logout'
  },
];
